import { service } from '@/utils/request'

export default {
  // 查询
  getList(params) {
    return service({
      url: '/cloud/course/v1/discipline/list',
      method: 'post',
      params
    })
  },
  // 创建
  create(data) {
    return service({
      url: '/cloud/course/v1/discipline/create',
      method: 'post',
      data: data
    })
  },
  // 绑定栏目
  courseBindColumn(data) {
    return service({
      url: '/cloud/course/v1/discipline/sub/bind',
      method: 'post',
      data: data
    })
  },
  // 删除栏目
  courseRemoveColumn(id) {
    return service({
      url: `/cloud/course/v1/discipline/sub/delete/${id}`,
      method: 'post'
    })
  },
  // 更新
  update(data) {
    return service({
      url: '/cloud/course/v1/discipline/modify',
      method: 'post',
      data: data
    })
  },
  // 详情
  detail(id) {
    return service({
      url: '/cloud/course/v1/discipline/detail/' + id,
      method: 'get'
    })
  },
  // 删除
  delete(id) {
    return service({
      url: '/cloud/course/v1/discipline/delete/' + id,
      method: 'post'
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/contentManage/courseSubject.js